import React from 'react'; // Required for React 17 with react-scripts 3.x
import { useTranslation } from 'react-i18next';

/**
 * Simple direction hook - determines if current language is RTL or LTR
 *
 * @returns {'rtl' | 'ltr'} Current text direction based on active language
 */
export const useDirection = () => {
  const { i18n } = useTranslation();
  const rtlLanguages = ['he', 'ar'];
  return rtlLanguages.includes(i18n.language) ? 'rtl' : 'ltr';
};

/**
 * Hook to check if current language is RTL
 *
 * @returns {boolean} True if current language is RTL (Hebrew or Arabic)
 */
export const useIsRTL = () => {
  const direction = useDirection();
  return direction === 'rtl';
};

/**
 * Utility function for class components (already using withTranslation HOC)
 *
 * @param {string} language - Language code (he, ar, en, ru)
 * @returns {'rtl' | 'ltr'} Text direction for the given language
 */
export const getDirection = (language) => {
  const rtlLanguages = ['he', 'ar'];
  return rtlLanguages.includes(language) ? 'rtl' : 'ltr';
};
